module.exports = __webpack_public_path__ + "img/athletics_icon_7.94575625.png";